import { render } from "./AnnuityPanel.vue?vue&type=template&id=4be6f2be&ts=true"
import script from "./AnnuityPanel.vue?vue&type=script&lang=ts"
export * from "./AnnuityPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__